"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var router_1 = require("@angular/router");
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
/**
 * Handle system's log out by routing the application to login page
 *
 * Created by Hayk.Andriasyan on 10/13/2017.
 */
var SystemLogoutHandler = /** @class */ (function () {
    function SystemLogoutHandler(sessionDataProvider, router, matDialog) {
        var _this = this;
        this.sessionDataProvider = sessionDataProvider;
        this.router = router;
        this.matDialog = matDialog;
        this._openSubscriptions = [];
        this._openSubscriptions.push(this.sessionDataProvider.isLoggedOn().subscribe(function (isLoggedIn) {
            if (!isLoggedIn) {
                _this.matDialog.closeAll();
                _this.router.navigate(['/login']);
            }
        }));
    }
    SystemLogoutHandler.prototype.ngOnDestroy = function () {
        this._openSubscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    SystemLogoutHandler = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.SessionDataProvider,
            router_1.Router,
            material_1.MatDialog])
    ], SystemLogoutHandler);
    return SystemLogoutHandler;
}());
exports.SystemLogoutHandler = SystemLogoutHandler;
//# sourceMappingURL=system-logout-handler.js.map